import { MenuModel } from 'src/app/core/models/security/menu/menu.model';
import { Injectable, inject, OnDestroy } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateFn
} from '@angular/router';
// import { AuthService } from './auth.service';
import { LoginResponseModel } from 'src/app/core/models/security/auth/login-response.model';
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    let currentUserValue: LoginResponseModel = this.authService.currentUserValue;

  if (!currentUserValue.kisiTokenDto?.isLogin) {
      this.authService.Logout();
      // var req = { Value: 2 };
      // let sbLogout = this.authService.Logout(req).subscribe();
      // this.subscriptions.push(sbLogout);

      return false;
    } else {
      if (currentUserValue.pageListDto.length > 0) {
        const currentUrl = state.url;
        if (currentUrl) {
          // Prefer route data pathData key when present (backend-defined permission path),
          // otherwise fall back to the actual URL-based check
          const pathData: string | undefined = next.data?.pathData;
          const match = this.authService.checkPageAccess(currentUrl, pathData);
          if (match) {
            return true;
          }
        }

        return this.yetkisizErisimiYonlendir(currentUrl);
      }
      else {
        this.authService.Logout()
        // var req = { Value: 2 };

        // let sbLogout = this.authService.Logout(req).subscribe();
        // this.subscriptions.push(sbLogout);

        return false;
      }
    }
  }

  /**
   * Yetkisiz erişimde kullanıcıyı GERÇEKTEN açabileceği bir sayfaya gönderir.
   *
   * Eskiden burada koşulsuz olarak getDefaultRoute()'a yönlendiriliyordu. Kullanıcının o
   * rotaya da yetkisi yoksa guard yeniden çalışıp yeniden aynı yere yönlendiriyordu:
   * kendine dönen sonsuz navigasyon, boş ekran ve donan tarayıcı. Rol simülasyonunda bir
   * firma rolüne geçince tam olarak bu yaşanıyordu — yetkiler simüle edilen rolden,
   * iniş rotası ise loginTip'ten hesaplandığı için ikisi ayrışıyordu.
   *
   * Üç koruma birden var:
   *  1. Yalnızca erişilebilir olduğu doğrulanmış bir rotaya yönlendirilir.
   *  2. Zaten o rotadaysak tekrar yönlendirilmez (aynı adrese döngü kurulamaz).
   *  3. Erişilebilir hiçbir sayfa yoksa yönlendirme durur, açıklayıcı ekran gösterilir.
   */
  private yetkisizErisimiYonlendir(currentUrl: string | null): boolean {
    const hedef = this.authService.getGuvenliYonlendirmeRotasi();

    if (!hedef) {
      this.router.navigate(['/error/yetkisiz']);
      return false;
    }

    // Hedef, halihazırda bulunduğumuz rotaysa yönlendirme döngü demektir.
    if (currentUrl && this.ayniRotaMi(currentUrl, hedef)) {
      this.router.navigate(['/error/yetkisiz']);
      return false;
    }

    this.router.navigate([hedef]);
    return false;
  }

  /** Sorgu parametrelerini ve baştaki/sondaki eğik çizgiyi yok sayarak karşılaştırır. */
  private ayniRotaMi(a: string, b: string): boolean {
    const sadelestir = (yol: string) =>
      yol.split('?')[0].split('#')[0].replace(/\/+$/, '').replace(/^\/+/, '').toLowerCase();

    return sadelestir(a) === sadelestir(b);
  }

  ngOnDestroy(): void {

    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

}
export const IsAuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> => {
  return inject(AuthGuard).canActivate(route, state)
}
